import { render, staticRenderFns } from "./OrderMealEdit.vue?vue&type=template&id=98145120&scoped=true"
import script from "./OrderMealEdit.vue?vue&type=script&lang=js"
export * from "./OrderMealEdit.vue?vue&type=script&lang=js"
import style0 from "./OrderMealEdit.vue?vue&type=style&index=0&id=98145120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98145120",
  null
  
)

export default component.exports